import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SubaccountService } from '../../../../services/subaccount.service';
import { SendSubaccountCreationLink } from '../../../../models/requests/send-subaccount-creation-request';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDivider } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-add-subaccount-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDivider,
    MatInputModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './add-subaccount-dialog.component.html',
  styleUrl: './add-subaccount-dialog.component.scss'
})
export class AddSubaccountDialogComponent {
  subaccountForm!: FormGroup;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddSubaccountDialogComponent>,
    private formBuilder: FormBuilder,
    private subaccountService: SubaccountService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.initFormGroup();
  }

  initFormGroup() {
    this.subaccountForm = this.formBuilder.group({
      targetEmail: [undefined, [Validators.required, Validators.email]]
    });
  }

  onSubmitForm() {
    if (this.subaccountForm.valid) {
      this.sendSubaccountCreationLink();
    }
  }

  sendSubaccountCreationLink() {
    this.isLoading = true;
    const request: SendSubaccountCreationLink = { targetEmail: this.subaccountForm.value['targetEmail'] }
    
    this.subaccountService.createSubAccountLink(request).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackBar.open("A subscription link was sent to your client's email.", 'Close', { duration: 5000 });
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  getF() {
    return this.subaccountForm.controls;
  }
}
